export class Step {
    text : string;
    translationKey? : string;
    completed? : boolean
    active? : boolean;
    allowSkip? : boolean;
    requirements? : {[key:string]:boolean} // for example {requiresUser:true}
  }